import { Globals } from '@theme/utils/globals';
import { environment } from '@env/environment';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { VALIDATION } from '@theme/utils/functions';
import { CONFIRMATION } from '@theme/utils/functions';
import { PaymentCustomer } from '@model/payment-customer';
import {EmitterService} from '@service/emitter/emitter.service';
import { UploaderService } from '@service/uploader/uploader.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentCustomerService } from '@service/payment-customer/payment-customer.service';
import { PaymentCustomerAddComponent } from '@client/payment/payment-customer-add/payment-customer-add.component';

@Component({
  selector: 'app-payment-customer-show',
  templateUrl: './payment-customer-show.component.html',
  styleUrls: ['./payment-customer-show.component.scss']
})
export class PaymentCustomerShowComponent implements OnInit {
  publicUrl = environment.publicUrl;
  title: string = ""
  payment: PaymentCustomer
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user;
  file: any;
  validation = VALIDATION
  confirmation = CONFIRMATION
  validate = false;

  constructor(
    public modale: NgbActiveModal,
    private modalService: NgbModal,
    private emitter: EmitterService,
    private uploader: UploaderService,
    private paymentCustomerService: PaymentCustomerService
  ) {
    this.validate = this.paymentCustomerService.validated
    this.payment = this.paymentCustomerService.getPayment()
    this.title = "Détails du paiement N° " + this.payment.code
  }

  ngOnInit(): void {
  }

  editPayment(row) {
    this.modalService.dismissAll()
    this.paymentCustomerService.setPayment(row)
    this.paymentCustomerService.edit = true
    this.paymentCustomerService.type = row.type
    this.modal(PaymentCustomerAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  printerPayment(row): void {
    this.paymentCustomerService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  validatePayment(row){
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment valider cet paiement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Valider <i class="fas fa-check"></i>',
      confirmButtonColor: 'green',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
      this.paymentCustomerService.validate(row).subscribe(res => {
        if (res?.status === 'success') {
          if (row) {
            this.modale.close('ferme');
            this.emitter.emit({action: 'PAYMENT_CUSTOMER_VALIDATE', payload: res?.data});
          }
        }
      });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
  showFile(item) {
    const fileByFolder = this.uploader.getDataFileByFolder();
    this.file = fileByFolder?.path ? this.publicUrl + '/' + fileByFolder?.path : null;
  }
  closeViewer() {
    this.file = '';
    this.uploader.setDataFileByFolder('');
  }
}
